// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderSignInDesktopTablet_container__FL322","signInButton":"HeaderSignInDesktopTablet_signInButton__3XB_L"};